import publicAppsClient from "../middleware/publicAppsClient";

/**
 * Banner telemetry for the CRM public apps API.
 *
 * Both endpoints are fire-and-forget: analytics must never surface an error to
 * the player or block the click-through, so a failed beacon resolves to false
 * instead of rejecting.
 *   POST api/v1/public/apps/banners/{id}/impression — banner was actually seen
 *   POST api/v1/public/apps/banners/{id}/click      — banner was clicked
 */
function trackBannerEvent(bannerId, event) {
  if (!bannerId) return Promise.resolve(false);

  return publicAppsClient
    .post(`banners/${bannerId}/${event}`)
    .then(() => true)
    .catch(() => false);
}

export function trackBannerImpression(bannerId) {
  return trackBannerEvent(bannerId, "impression");
}

export function trackBannerClick(bannerId) {
  return trackBannerEvent(bannerId, "click");
}
